import Footer from '@fs/zion-footer'
import React, { useRef, lazy, Suspense } from 'react'
import PropTypes from 'prop-types'
import { useNonReligiousMode } from '@fs/zion-permissions'
import Wrapper from './shared/components/Wrapper'
import useHeightAdjustment from './shared/hooks/useHeightAdjustment'
import { needsBaseUrlPrefix } from './shared/needsBaseUrlPrefix'

const AnalyticsPageView = lazy(() => import('./helpers/AnalyticsPageView'))

export default function FooterApp({ mockFlags, mockActivities, analyticsPageName, hideLinksBand }) {
  const ref = useRef(null)
  useHeightAdjustment(ref)
  const [nonReligiousModeCheck, status, error] = useNonReligiousMode()
  const nonReligiousMode = status === 'loading' || error !== null || nonReligiousModeCheck

  return (
    <div ref={ref}>
      <Wrapper mockFlags={mockFlags} mockActivities={mockActivities}>
        <Footer nonReligiousMode={nonReligiousMode} external={needsBaseUrlPrefix()} hideLinksBand={hideLinksBand} />
        {analyticsPageName ? (
          <Suspense fallback={null}>
            <AnalyticsPageView pageName={analyticsPageName} />
          </Suspense>
        ) : null}
      </Wrapper>
    </div>
  )
}

FooterApp.propTypes = {
  mockFlags: PropTypes.objectOf(
    PropTypes.shape({
      treatment: PropTypes.bool,
    })
  ),
  mockActivities: PropTypes.objectOf(
    PropTypes.shape({
      experienceId: PropTypes.string,
      color: PropTypes.string,
      buttonEmphasis: PropTypes.string,
    })
  ),
  analyticsPageName: PropTypes.string,
  hideLinksBand: PropTypes.bool,
}
